const viewAllLineItemsButton = document.querySelector(
  "[data-toggle-lineitems-table]",
);
// Packages with less than 5 items will not have the collapseable element
if (viewAllLineItemsButton) {
  const lineItemsTable = document.querySelector(".tqc-line-items");
  const labelSpan = viewAllLineItemsButton.querySelector("span");
  const iconUse = viewAllLineItemsButton.querySelector("svg use");
  const originalLabel = viewAllLineItemsButton.dataset.originalLabel;

  viewAllLineItemsButton.addEventListener("click", () => {
    const isCollapsed = lineItemsTable.classList.contains(
      "tqc-line-items--collapsed",
    );

    if (isCollapsed) {
      lineItemsTable.classList.remove("tqc-line-items--collapsed");
      labelSpan.textContent = "Show less";
      iconUse.setAttribute("xlink:href", "#caret-up");
    } else {
      lineItemsTable.classList.add("tqc-line-items--collapsed");
      labelSpan.textContent = originalLabel;
      iconUse.setAttribute("xlink:href", "#caret-down");
    }
  });
}
